import {useDispatch, useSelector} from "react-redux";
import {getAssetId1, getAssetId2, getPairStorage, removeStoredPair, setAssetId1, setAssetId2, setStorePair} from "../../ducks/comparator-duck.js";
import {assetTypeToGroup, getSpecificAsset} from "../../ducks/assets-duck.js";
import './ComparatorStoredPairs.scss'
import Button from "../util/Button.jsx";
import ContentSaveOutlineIcon from "mdi-react/ContentSaveOutlineIcon.js";
import CloseIcon from "mdi-react/CloseIcon.js";
import AssetListIcon from "../util/icons/AssetListIcon.jsx";

export default () => {

    const dispatch = useDispatch()
    const storedPairs = useSelector(getPairStorage)

    return (
        <div className='comparator-stored-pairs flex-vertical-center'>
            {storedPairs.map((pair, idx) => {
                const [assetId1, assetId2] = pair
                return (
                    <Asset
                        key={idx}
                        idx={idx}
                        assetId1={assetId1}
                        assetId2={assetId2}
                    />
                )
            })}
            <Button
                onClick={() => dispatch(setStorePair())}
                icon={<ContentSaveOutlineIcon />}
                className='save-button'
            />
        </div>
    )
}

const Asset = ({idx, assetId1, assetId2}) => {

    const dispatch = useDispatch()

    const {code: code1, name: name1, asset_type: assetType1} = useSelector(state => getSpecificAsset(state, assetId1))
    const {code: code2, name: name2, asset_type: assetType2} = useSelector(state => getSpecificAsset(state, assetId2))

    const selectedAssetId1 = useSelector(getAssetId1)
    const selectedAssetId2 = useSelector(getAssetId2)
    const isSelected = (assetId1 === selectedAssetId1 && assetId2 === selectedAssetId2)
        || (assetId1 === selectedAssetId2 && assetId2 === selectedAssetId1)

    const setPair = () => {
        dispatch(setAssetId1(assetId1))
        dispatch(setAssetId2(assetId2))
    }

    const removePair = e => {
        e.stopPropagation()
        dispatch(removeStoredPair(idx))
    }

    return (
        <Button onClick={setPair} className={`pair ${isSelected ? 'is-selected' : ''}`}>
            <div className='asset asset-1 flex-vertical-center'>
                {assetType1 &&
                <AssetListIcon name={name1} assetGroup={assetTypeToGroup(assetType1)}/>
                }
                {code1}
            </div>
            <div className='dull small vs'>
                vs
            </div>
            <div className='asset asset-2 flex-vertical-center'>
                {assetType2 &&
                <AssetListIcon name={name2} assetGroup={assetTypeToGroup(assetType2)}/>
                }
                {code2}
            </div>
            <div className='remove-icon' onClick={removePair}>
                <CloseIcon />
            </div>
        </Button>
    )
}